module.exports = __webpack_public_path__ + "img/bus-partner-img10.3063f6aa.png";